<div class="row my-2">
  <div class="col-12">
    <it-breadcrumb separator="/">
      <it-breadcrumb-item *ngFor="let item of items" class="me-1" [href]="item.link">
        {{ item.label }}
      </it-breadcrumb-item>
    </it-breadcrumb>
  </div>
  <div class="col-6">
    <h3>Utenti master</h3>
  </div>
  <div class="col-6 d-flex justify-content-end">
    <it-back-button></it-back-button>
  </div>
</div>
<div class="pb-2 mb-2">
  <p>
    Qui trovi la lista degli utenti master associati all'ente. <br>
    Per ciascun utente potrai visualizzare i dettagli, attivare o disattivare la sua utenza.
  </p>
  <div class="row g-4">
    <div class="col-12">
      @if (!ente.isSolaLettura) {
      <div class="d-flex justify-content-end">
        <button (click)="add()" type="button" class="btn btn-primary">Aggiungi</button>
      </div>
      }
      <it-modal #utenteMasterModal="itModal" size="lg" backdrop="static" keyboard="false">
        <ng-container modalTitle>Dati utente master</ng-container>
        <ng-container description>
          <form class="mt-2" [formGroup]="form">
            <app-utente [formArrayGroup]="form" [nome]="nome" [cognome]="cognome" [sesso]="sesso"
              [dataNascita]="dataNascita" [luogoNascita]="luogoNascita" [codiceFiscale]="codiceFiscale" [email]="email"
              [confermaEmail]="confermaEmail" [telefono]="telefono" [reset]="reset" [editMode]="editMode"
              [editable]="editable"></app-utente>
          </form>
        </ng-container>
        <ng-container footer>
          <button itButton="primary" size="sm" type="button"
            [disabled]="form.invalid || ente.isSolaLettura || !editable" (click)="submit()">Salva</button>
        </ng-container>
      </it-modal>
    </div>
    @if (utenti.length > 0) {
    <it-table itSort (sortChange)="sortData($event)">
      <ng-container thead>
        <tr>
          <th scope="col">Utente</th>
          <th scope="col">Stato</th>
          <!-- <th it-sort-header="cognome" scope="col">Cognome</th>
          <th it-sort-header="codiceFiscale" scope="col">Codice fiscale</th>
          <th it-sort-header="email" scope="col">Email</th> -->
          <th scope="col">Attiva/Disattiva</th>
          <th scope="col">Conferma dati</th>
          <th scope="col"></th>
        </tr>
      </ng-container>

      <ng-container tbody>
        @for (element of utenti; track element.idUtenteMaster) {
        <tr>
          <td [title]="element.nome + ' ' + element.cognome" class="text-truncate col-width-200">
            <div>
              {{element.nome + ' ' + element.cognome }}
            </div>
            <div class="fw-semibold">
              {{ element.email }}
            </div>
          </td>
          <!-- <td [title]="element.nome">{{element.nome ?? '' | truncate: 15: '...'}}</td>
          <td [title]="element.cognome">{{element.cognome ?? '' | truncate: 15: '...'}}</td>
          <td [title]="element.codiceFiscale">{{element.codiceFiscale}}</td>
          <td [title]="element.email">{{element.email?? '' | truncate: 25: '...'}}</td> -->
          <td [title]="element.statoUtenteMaster?.descrizione">
            {{ element.statoUtenteMaster?.descrizione }}
          </td>
          <td [title]="element.isAttivo ? 'Attivo' : 'Disattivo'" class="col-width-100">
            <div class="d-flex justify-content-start">
              <app-badge [element]="element"></app-badge>
            </div>
          </td>
          <td title="Conferma dati" class="col-width-100">
            @if (element.isAbilitabile && !ente.isSolaLettura) {
              <button itButton="primary" size="xs" type="button" [disabled]="!element.isAbilitabile || ente.isSolaLettura"
              (click)="abilitaModal.toggle()">Invia
            </button>
            }
            <it-modal #abilitaModal="itModal" closeButton="false">
              <ng-container modalTitle>Conferma dati utente</ng-container>
              <ng-container description>
                <p>Sei sicuro di voler confermare i dati dell'utente <strong>{{element.email}}</strong>?</p>
              </ng-container>
              <ng-container footer>
                <button itButton="outline-primary" size="sm" type="button" data-bs-dismiss="modal">Annulla</button>
                <button itButton="primary" size="sm" type="button" (click)="confirmData(element)"
                  data-bs-dismiss="modal">Conferma</button>
              </ng-container>
            </it-modal>
          </td>
          <td title="Azioni" class="col-width-100">
            <a onclick="return false" href="/" (click)="edit(element)"
              [title]="!element.flagPrincipale && !element.flagPrivacy && element.statoUtenteMaster?.consenteModifica && element.codiceFiscale != this.user.idUtente && !this.ente.isSolaLettura ? 'Modifica' : 'Dettaglio'" class="me-2">
              <it-icon [name]="!element.flagPrincipale && !element.flagPrivacy && element.statoUtenteMaster?.consenteModifica && element.codiceFiscale != this.user.idUtente && !this.ente.isSolaLettura ? 'pencil' : 'search'" color="primary"
                size="sm"></it-icon>
            </a>
            @if (!element.flagPrincipale && element.statoUtenteMaster?.consenteModifica && element.codiceFiscale != this.user.idUtente && !ente.isSolaLettura) {
            <a onclick="return false" href="/" (click)="confirmModal.toggle()" title="Elimina">
              <it-icon name="delete" color="danger" size="sm"></it-icon>
            </a>
            <it-modal #confirmModal="itModal" closeButton="false">
              <ng-container modalTitle>Conferma eliminazione</ng-container>
              <ng-container description>
                <p>Sei sicuro di voler eliminare l'utente master <strong>{{element.email}}</strong>?</p>
              </ng-container>
              <ng-container footer>
                <button itButton="outline-primary" size="sm" type="button" data-bs-dismiss="modal">Annulla</button>
                <button itButton="primary" size="sm" type="button" (click)="delete(element)"
                  data-bs-dismiss="modal">Conferma</button>
              </ng-container>
            </it-modal>
            }
          </td>
        </tr>
        }
      </ng-container>
    </it-table>
    <it-pagination *ngIf="totalPages > 0" alignment="center" [currentPage]="currentPage" [pageNumbers]="totalPages"
      [currentChanger]="pageOffset" (changerEvent)="changerEvent($event)" (pageEvent)="getPage($event)">
    </it-pagination>
    } @else {
    <h5 class="text-center">Nessun utente censito</h5>
    }
  </div>
</div>
<it-notifications></it-notifications>
